/// <reference path="skyward.ui.reporting.js" />
(
    function (skyward, $)
    {
        "use strict";
        skyward.reportingSorts = skyward.reportingSorts || {};
        let sectionDisplayOnSingleLine = false;

        skyward.reportingSorts.pageBreakOptions =
        {
            True: "True",
            False: "False",
            Burst: "Burst"
        }

        skyward.reportingSorts.editSorts = function (dataLines, sectionData, reportType, allowKeepTogether, calculatedFields)
        {
            const deferred = $.Deferred();
            sectionDisplayOnSingleLine = sectionData.displayOnSingleLine;

            $.ajax(
                {
                    url: skyward.global.virtualDir + "Reporting/Report/GetSortEditor",
                    type: "POST",
                    dataType: "JSON",
                    data:
                    {
                        reportSorts: skyward.extensions.encodeHtml(JSON.stringify(sectionData.reportSorts)),
                        reportLines: skyward.extensions.encodeHtml(JSON.stringify(dataLines)),
                        prompts: skyward.reporting.prompts.promptCollection.toJsonString(),
                        rootObject: sectionData.rootObject,
                        rootModule: sectionData.rootModule,
                        baseObject: sectionData.baseObject,
                        baseModule: sectionData.baseModule,
                        promptForSortOrder: sectionData.promptForSortOrder,
                        sortPromptGuid: sectionData.sortPromptGuid,
                        sortPromptLabel: skyward.extensions.encodeHtml(sectionData.sortPromptLabel),
                        relationshipPath: sectionData.entireRelationshipPath,
                        reportType: reportType,
                        sectionName: skyward.extensions.encodeHtml(sectionData.displayName),
                        calculatedFieldsJson: JSON.stringify(calculatedFields),
                        allowKeepTogether: allowKeepTogether && !sectionData.displayOnSingleLine
                    }
                }).done(function (data)
                {
                    showPopup(data).done(function (sortData)
                    {
                        deferred.resolve(sortData);
                    });
                });
            return deferred; //Wait for user to finish
        };

        function showPopup(data)
        {
            const html = $(data.html);
            const buttons = [
                { text: "Save", click: confirmEdit, icon: "Save" },
                { text: "Cancel", click: cancelEdit, icon: "Cancel" }
            ];
            const popup = skyward.modalLayer.showDialog("Section Sorts", html, buttons, { closeOnClick: false, draggable: true, automationID: "section-sorts-dialog" });
            const editor = popup.content;
            const editorButtons = {
                moveUp: editor.find('.moveItem.up'),
                moveDown: editor.find('.moveItem.down'),
                add: editor.find('.addItem'),
                remove: editor.find('.removeItem')
            };
            const sortsEditor = editor.find('.reportDefinitionSortsEditor');
            $.when(popup.bodyPromise).then(function ()
            {
                if (data.errors)
                {
                    skyward.validation.displayValidationMessages(data, sortsEditor, null);
                }
            });

            editor.find(".sortItem").on("click", function ()
            {
                const row = $(this);
                const button = row.find(".selectSort");
                selectRow(button);
                setActiveButtonsBasedOnCurrentRow(row);
            });

            const selectedColumns = editor.find(".selectedItemsTable tbody");
            selectedColumns.on('click', '.selectSort', selectItemFromSelectedColumns)
                .on('change', '.pageBreakColumn .pageBreak', togglePageBreak)
                .on('click', '.sortDirectionColumn', toggleDirection)
                .on('click', '.keepTogether', toggleKeepTogether)
                .on('click', '.createBookmark', toggleCreateBookmark)
                .on('click', '.selectSort', removeSelectedItem)
                .on('click', '.sortIconColumn .edit', editFieldNameMode)
                .on('click', '.sortIconColumn .info', getInfoPopup);

            const availableColumns = editor.find(".availableItemsTable tbody");
            availableColumns.on('click', '.selectSort', selectItemFromAvailableColumns)
                .on('click', '.selectSort', addSelectedItem);

            const addPromptForSorts = editor.find(".promptForSortOrder");
            addPromptForSorts.on("change", updatePromptSort);

            editorButtons.add.on('click', addSelectedItem);
            editorButtons.remove.on('click', removeSelectedItem);
            editorButtons.moveUp.on('click', moveSelectedItemUp);
            editorButtons.moveDown.on('click', moveSelectedItemDown);

            const pageBreakContainer = editor.find(".pageBreakColumn .conditionValuesContainer");
            $.each(pageBreakContainer, function (index, container)
            {
                $(container).toggleClass("ui-disabled", sectionDisplayOnSingleLine);
            });

            const waitUntilDoneEditing = $.Deferred().always(function () { popup.close(); });
            return waitUntilDoneEditing;

            // End-of-lifecycle methods
            function cancelEdit()
            {
                waitUntilDoneEditing.reject();
            }

            function confirmEdit()
            {
                skyward.validation.displayValidationMessages(data, sortsEditor, null);

                const sortPromptLabel = editor.find(".sortPromptLabel");
                const sortData =
                {
                    selectedSorts: [],
                    removedSorts: [],
                    sortPrompt:
                    {
                        label: sortPromptLabel.val(),
                        promptGuid: sortPromptLabel.data("sortPromptGuid"),
                        promptForSortOrder: false
                    }
                };

                for (const selectedSort of selectedColumns[0].children)
                {
                    const data = $(selectedSort).data();
                    if (data.hasErrors)
                    {
                        return; // don't allow to save with error sorts
                    }
                    data.friendlyName = selectedSort.dataset.friendlyName; // so jquery doesn't try parsing the name as an object
                    sortData.selectedSorts.push(data);
                }

                availableColumns.children('[data-existing-sort]').each(function ()
                {
                    sortData.removedSorts.push($(this).data());
                });

                if (addPromptForSorts.is(":checked"))
                {
                    sortData.sortPrompt.promptForSortOrder = true;
                }
                waitUntilDoneEditing.resolve(sortData);
            }

            // Interaction methods
            function addSelectedItem()
            {
                if (editorButtons.add.hasClass('ui-disabled'))
                {
                    return;
                }
                const selectedRow = getSelectedRow(editor);
                skyward.svg.swapSvg(selectedRow.find(".addPlus"), "Clear", "BrowseLevel");

                const primaryKeySort = getPrimaryKeyRow(editor);
                if (primaryKeySort.length > 0)
                {
                    selectedRow.insertBefore(primaryKeySort);
                }
                else
                {
                    selectedColumns.append(selectedRow);
                }
                setActiveButtonsBasedOnCurrentRow(selectedRow);
            }

            function removeSelectedItem()
            {
                const selectedRow = getSelectedRow(editor);
                if (editorButtons.remove.hasClass('ui-disabled') || selectedRow.data('isPrimaryKeySort'))
                {
                    return;
                }
                if (selectedRow.data().hasErrors)
                {
                    selectedRow.remove();
                    selectedColumns.trigger('change');
                    const selectedItem = selectRow(selectedColumns.children().first());
                    setActiveButtonsBasedOnCurrentRow(selectedItem);
                    return;
                }

                selectedRow.data("friendlyName", "");
                skyward.svg.swapSvg(selectedRow.find(".clear"), "AddPlus", "BrowseLevel");

                const editFieldTextBox = selectedRow.find(".editField");
                editFieldTextBox.val("");
                selectedRow.find(".fieldNameColumn span").text(editFieldTextBox.attr("placeholder"));
                availableColumns.append(selectedRow);
                setActiveButtons({ add: true });
            }

            function moveSelectedItemUp()
            {
                const selectedRow = getSelectedRow(editor);
                if (editorButtons.moveUp.hasClass('ui-disabled') || selectedRow.data('isPrimaryKeySort'))
                {
                    return;
                }

                const previousRow = selectedRow.prev('.sortItem');
                if (previousRow.length > 0)
                {
                    const isTopItem = previousRow.prev('.sortItem').length === 0;
                    selectedRow.detach().insertBefore(previousRow);
                    setActiveButtons({ remove: true, down: true, up: !isTopItem });
                }
            }

            function moveSelectedItemDown()
            {
                if (editorButtons.moveDown.hasClass('ui-disabled'))
                {
                    return;
                }

                const selectedRow = getSelectedRow(editor);
                const isPrimaryKeySort = selectedRow.data('isPrimaryKeySort');
                const nextRow = selectedRow.next('.sortItem');
                if (nextRow.length > 0 && !nextRow.data('isPrimaryKeySort'))
                {
                    const nextRowNextSortItem = nextRow.next('.sortItem');
                    const isBottomItem = nextRowNextSortItem.length === 0 || nextRowNextSortItem.data('isPrimaryKeySort');
                    selectedRow.detach().insertAfter(nextRow);
                    setActiveButtons({ remove: !isPrimaryKeySort, down: !isBottomItem, up: !isPrimaryKeySort });
                }
            }

            function editFieldNameMode()
            {
                const editButton = $(this);
                const okButton = editButton.siblings(".confirmEdit");
                const cancelButton = editButton.siblings(".cancelEdit");
                const infoButton = editButton.siblings(".info");

                const fieldNameColumn = editButton.parent(".sortIconColumn").siblings(".fieldNameColumn");
                const selectSortButton = fieldNameColumn.find(".selectSort");
                const friendlyNameLabel = fieldNameColumn.find(".friendlyName");
                const fieldNameTextBox = fieldNameColumn.find(".editField");

                const sort = editButton.closest(".sortItem");

                updateEditMode(true);

                okButton.on("click", function ()
                {
                    selectRow(fieldNameTextBox);
                    const friendlyName = fieldNameTextBox.val();
                    if (friendlyName)
                    {
                        const friendlyNameDisplayString = createFriendlyNameDisplay(friendlyName);
                        sort[0].dataset.friendlyName = friendlyNameDisplayString;
                        friendlyNameLabel.text(friendlyNameDisplayString);
                    }
                    else
                    {
                        fieldNameTextBox.val(selectSortButton.find(".textAfter").text());
                    }
                    updateEditMode(false);
                });

                function createFriendlyNameDisplay(friendlyName)
                {
                    const reversedString = friendlyName.split('').reverse();
                    let numCharsSinceLastSpace = 0;
                    const tempStringArray = [];

                    for (let i = 0; i < reversedString.length && tempStringArray.length <= 90; i++)
                    {
                        const character = reversedString[i];
                        if (character === " ")
                        {
                            numCharsSinceLastSpace = 0;
                        }
                        else
                        {
                            numCharsSinceLastSpace++;
                            if (numCharsSinceLastSpace === 30)
                            {
                                tempStringArray.push(" ");
                                numCharsSinceLastSpace = 0;
                            }
                        }
                        tempStringArray.push(character);
                    }

                    return (tempStringArray.length < friendlyName.length ? "..." : "") + tempStringArray.reverse().join("");
                }

                cancelButton.on("click", function ()
                {
                    fieldNameTextBox.val(selectSortButton.find(".textAfter").text());
                    selectRow($(this));
                    updateEditMode(false);
                });

                function updateEditMode(enterEditMode)
                {
                    if (enterEditMode)
                    {
                        setActiveButtons({ add: false, up: false, down: false, remove: false });
                    }
                    else
                    {
                        const selectedRow = getSelectedRow(editor);
                        const previousRow = selectedRow.prev('.sortItem');
                        const nextRow = selectedRow.next('.sortItem');
                        const args = {
                            remove: true,
                            down: nextRow.length > 0,
                            up: previousRow.length > 0
                        };
                        setActiveButtons(args);
                    }


                    editButton.toggleClass("hidden", enterEditMode);
                    infoButton.toggleClass("hidden", enterEditMode);
                    selectSortButton.toggleClass("hidden", enterEditMode);
                    friendlyNameLabel.toggleClass("hidden", enterEditMode);
                    okButton.toggleClass("hidden", !enterEditMode);
                    cancelButton.toggleClass("hidden", !enterEditMode);
                    fieldNameTextBox.toggleClass("hidden", !enterEditMode);
                }
            }

            function getInfoPopup()
            {
                const infoButton = $(this);
                const row = selectRow(infoButton);
                const rowData = row.data();

                const outerDiv = $("<div/>");
                const idGenerator = skyward.extensions.getIdGenerator("popup", "_sortInfoPopupLabel");
                const fieldNameTextBox = buildReadOnlyTextbox("sortInfoPopupLabel", rowData.fieldName, idGenerator);
                const fieldNameFieldset = buildFieldset().append(buildLabel("title", "Field Name ", fieldNameTextBox.attr("id"))).append(fieldNameTextBox);

                outerDiv.append(fieldNameFieldset);

                skyward.modalLayer.showInformationDialog("Sort Information", outerDiv, null, { anchorTo: infoButton });
            }

            function buildFieldset()
            {
                return $("<div class='fieldWrapper' />");
            }

            function buildLabel(className, text, forId)
            {
                return $("<label/>", { for: forId}).text(text).addClass(className);
            }

            function buildReadOnlyTextbox(className, text, idGenerator)
            {
                const textbox = $("<input/>",
                    {
                        id: idGenerator.getNewId(),
                        readonly: "true",
                        type: "text"
                    }).addClass(`${className} ui-disabled`);
                if (text == "")
                {
                    return textbox;
                }
                return textbox.val(text);
            }

            function updatePromptSort()
            {
                const checkBox = $(this);
                if (checkBox.is(":checked"))
                {
                    editor.find(".sortPromptLabelFieldset").removeClass("hidden");
                }
                else
                {
                    editor.find(".sortPromptLabelFieldset").addClass("hidden");
                }
                popup.animateModalContents();
            }

            function toggleDirection()
            {
                const row = getParentRow(this);
                const isDesc = row.find('.desc > input').prop('checked');
                row.data("descending", isDesc);
            }

            function toggleKeepTogether()
            {
                const row = getParentRow(this);
                const keepLinesTogether = row.find('.keepTogether').prop('checked');
                row.data("keepLinesTogether", keepLinesTogether);

                if (keepLinesTogether)
                {
                    editor.find('.keepTogether:checked').not(this).each(function (i, e)
                    {
                        getParentRow(e).data("keepLinesTogether", false);
                        $(e).prop('checked', false);
                    });
                }
            }

            function toggleCreateBookmark()
            {
                const row = getParentRow(this);
                const createBookmark = row.find('.createBookmark').prop('checked');
                row.data("createBookmark", createBookmark);
            }

            function togglePageBreak()
            {
                const pageBreakSpan = $(this);
                const data = pageBreakSpan.data();

                const sortItem = getParentRow(this);

                if (data.promptUniqueId)
                {
                    sortItem.data("pageBreak", skyward.reportingSorts.pageBreakOptions.False);
                    sortItem.data("pageBreakPromptUniqueId", data.promptUniqueId);
                }
                else if (data.enumValue)
                {
                    sortItem.data("pageBreakPromptUniqueId", null);
                    sortItem.data("pageBreak", data.enumValue);
                }
            }

            function selectRow(button)
            {
                const row = getParentRow(button);

                const currentSelectedRow = getSelectedRow(editor);
                if (currentSelectedRow.find(".editField").is(":visible"))
                {
                    return currentSelectedRow;
                }
                currentSelectedRow.removeClass("ui-selected");
                row.addClass("ui-selected").focus();
                editor.find('.selectedColumnDataPath').text(row.attr('data-field-name'));
                editor.find('.selectedColumnDataPathLabel').show();
                popup.animateModalContents();
                return row;
            }

            function selectItemFromAvailableColumns()
            {
                selectRow(this);
                setActiveButtons({ add: true });
            }

            function selectItemFromSelectedColumns()
            {
                const selectedItem = selectRow(this);

                setActiveButtonsBasedOnCurrentRow(selectedItem);
            }

            function setActiveButtonsBasedOnCurrentRow(currentRow)
            {
                const isSelectedTable = currentRow.closest(".selectedItemsTable").length > 0;
                let downButtonActive = false;
                let upButtonActive = false;
                const isPrimaryKeySort = currentRow.data('isPrimaryKeySort');

                if (isSelectedTable)
                {
                    const nextItem = currentRow.next('.sortItem');
                    if (nextItem.length > 0 && !nextItem.data('isPrimaryKeySort'))
                    {
                        downButtonActive = true;
                    }

                    const previousItem = currentRow.prev('.sortItem');
                    if (previousItem.length > 0 && !isPrimaryKeySort)
                    {
                        upButtonActive = true;
                    }
                }

                setActiveButtons({ up: upButtonActive, down: downButtonActive, remove: isSelectedTable && !isPrimaryKeySort, add: !isSelectedTable });
            }

            // accepts args = {add: bool, up: bool, down: bool, remove: bool}
            function setActiveButtons(args)
            {
                editorButtons.remove.toggleClass('ui-disabled', !args.remove);
                editorButtons.add.toggleClass('ui-disabled', !args.add);
                editorButtons.moveUp.toggleClass('ui-disabled', !args.up);
                editorButtons.moveDown.toggleClass('ui-disabled', !args.down);
            }
        }

        function getParentRow(button)
        {
            return $(button).closest('tr');
        }

        function getSelectedRow(editor)
        {
            return editor.find('.ui-selected');
        }

        function getPrimaryKeyRow(editor)
        {
            return editor.find('[data-is-primary-key-sort]');
        }

    }(window.skyward = window.skyward || {}, window.jQuery)
);
